if (!customElements.get('green24-gallery-viewer')) {
    customElements.define('green24-gallery-viewer', class extends HTMLElement {
      connectedCallback() {
        if (this.abort && !this.abort.signal.aborted) return;
        this.gallery = this.parentElement.querySelector('media-gallery');
        this.dialog = this.querySelector('dialog');
        if (!this.gallery || !this.dialog || !this.dialog.showModal) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.thumbs = Array.from(this.querySelectorAll('[data-viewer-thumb]'));
        this.images = this.thumbs.map(button => ({ id: button.dataset.imageId, src: button.dataset.source, width: Number(button.dataset.width), ratio: Number(button.dataset.ratio), alt: button.dataset.alt, branded: button.dataset.branded === 'true' }));
        this.stage = this.querySelector('[data-viewer-stage]');
        this.canvas = this.querySelector('[data-viewer-canvas]');
        this.image = this.querySelector('[data-viewer-image]');
        this.brand = this.querySelector('[data-viewer-brand]');
        this.pane = this.querySelector('[data-magnifier]');
        this.paneImage = this.querySelector('[data-magnifier-image]');
        this.lens = this.querySelector('[data-lens]');
        this.zoom = 1; this.panX = 0; this.panY = 0;
        this.pointers = new Map(); this.lastTap = null; this.pinching = false;
        if ('PointerEvent' in window && this.stage.setPointerCapture) {
          this.stage.dataset.g24GestureReady = 'true';
          this.classList.add('has-touch-gestures');
        }
        this.rails = [];
        const nativeList = this.gallery.querySelector('[id^="GalleryThumbnails"] .thumbnail-list');
        if (nativeList) this.setupRail(nativeList, true, options);
        this.viewerRail = this.setupRail(this.querySelector('.g24-image-dialog__thumbnails'), false, options);
        this.stageResize = new ResizeObserver(() => { if (this.dialog.open) { this.clearGesture(); this.setZoom(1); } });
        this.stageResize.observe(this.stage);
        this.querySelector('[data-open-viewer]').addEventListener('click', event => this.open(this.activeId(), event.currentTarget), options);
        this.gallery.addEventListener('click', event => {
          const trigger = event.target.closest('.product__modal-opener--image .product__media-toggle');
          if (!trigger || !this.images.some(image => image.id === trigger.dataset.mediaId)) return;
          event.preventDefault(); event.stopImmediatePropagation(); this.open(trigger.dataset.mediaId, trigger);
        }, { ...options, capture: true });
        document.addEventListener('click', event => {
          const link = event.target.closest('a[href]');
          if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || this.dialog.open) return;
          if (!link.closest('.g24-story,.g24-editorial-chapter,.green24-product-details') || !link.querySelector('img')) return;
          this.registerStoryImages(options);
          const key = this.imageKey(link.href);
          const match = this.images.find(image => this.imageKey(image.src) === key);
          if (!match) return;
          event.preventDefault(); this.open(match.id, link);
        }, options);
        this.querySelector('[data-close-viewer]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          this.clearGesture();
          document.body.style.overflow = this.previousOverflow;
          const selected = this.images[this.index];
          if (selected && this.gallery.querySelector(`[data-media-id="${this.dataset.section}-${selected.id}"]`) && this.gallery.setActiveMedia) this.gallery.setActiveMedia(`${this.dataset.section}-${selected.id}`, false);
          this.opener?.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
        this.thumbs.forEach((button,index) => button.addEventListener('click', () => this.select(index), options));
        this.querySelector('[data-previous]').addEventListener('click', () => this.select(this.index - 1), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.select(this.index + 1), options);
        this.querySelector('[data-zoom-in]').addEventListener('click', () => this.setZoom(this.zoom + .5), options);
        this.querySelector('[data-zoom-out]').addEventListener('click', () => this.setZoom(this.zoom - .5), options);
        this.querySelector('[data-fit]').addEventListener('click', () => this.setZoom(1), options);
        this.dialog.addEventListener('keydown', event => {
          if (event.target === this.stage && this.zoom > 1 && ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(event.key)) {
            event.preventDefault();
            this.panX += event.key === 'ArrowLeft' ? 60 : event.key === 'ArrowRight' ? -60 : 0;
            this.panY += event.key === 'ArrowUp' ? 60 : event.key === 'ArrowDown' ? -60 : 0;
            this.positionImage(); return;
          }
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
        }, options);
        this.stage.addEventListener('pointerdown', event => this.startPointer(event), options);
        this.stage.addEventListener('pointermove', event => this.movePointer(event), options);
        this.stage.addEventListener('pointerup', event => this.endPointer(event), options);
        this.stage.addEventListener('pointercancel', () => this.clearGesture(), options);
        this.stage.addEventListener('lostpointercapture', event => { if (this.pointers.has(event.pointerId)) this.clearGesture(); }, options);
        this.stage.addEventListener('wheel', event => {
          if (this.zoom<=1 || event.ctrlKey) return;
          event.preventDefault(); this.panX-=event.deltaX; this.panY-=event.deltaY; this.positionImage();
        }, { ...options, passive:false });
        this.gallery.addEventListener('pointermove', event => {
          if (event.pointerType === 'mouse') this.magnify(event);
          else this.hideMagnifier();
        }, { ...options, passive: true });
        this.gallery.addEventListener('mouseleave', () => this.hideMagnifier(), options);
        window.addEventListener('scroll', () => this.hideMagnifier(), { ...options, passive: true });
        window.addEventListener('resize', () => { this.hideMagnifier(); if (this.dialog.open) { this.clearGesture(); this.setZoom(1); } }, options);
        this.hidden = false;
      }
      disconnectedCallback() {
        this.clearGesture();
        if (this.dialog?.open) this.dialog.close(); this.abort?.abort(); this.stageResize?.disconnect();
        this.rails?.forEach(rail => { rail.resize.disconnect(); rail.mutation?.disconnect(); });
      }
      setupRail(list, native, options) {
        let wrapper;
        if (native) { wrapper=list.parentElement; wrapper.classList.add('g24-thumb-rail','g24-native-rail'); }
        else {
          wrapper=list.parentElement.classList.contains('g24-viewer-rail') ? list.parentElement : document.createElement('div');
          if (!wrapper.classList.contains('g24-viewer-rail')) { list.before(wrapper); wrapper.append(list); }
          wrapper.classList.add('g24-thumb-rail','g24-viewer-rail');
        }
        wrapper.querySelectorAll('[data-g24-rail-control]').forEach(button=>button.remove());
        const previous=document.createElement('button'), next=document.createElement('button');
        for (const [button,direction,label] of [[previous,-1,this.dataset.railPrevious],[next,1,this.dataset.railNext]]) {
          button.type='button'; button.className='g24-rail-control'; button.dataset.g24RailControl=String(direction);
          button.setAttribute('aria-label',label); button.innerHTML=direction<0 ? '<span aria-hidden="true">‹</span>' : '<span aria-hidden="true">›</span>';
          button.addEventListener('click',()=> {
            const vertical=matchMedia(native?'(min-width:990px)':'(min-width:750px)').matches;
            const step=(vertical?list.clientHeight:list.clientWidth)*.8*direction;
            list.scrollBy({top:vertical?step:0,left:vertical?0:step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
          },options);
        }
        list.before(previous); list.after(next);
        const update=()=> {
          const vertical=matchMedia(native?'(min-width:990px)':'(min-width:750px)').matches;
          wrapper.classList.toggle('g24-rail-vertical',vertical);
          const extent=vertical?list.scrollHeight-list.clientHeight:list.scrollWidth-list.clientWidth;
          const position=vertical?list.scrollTop:list.scrollLeft;
          previous.hidden=next.hidden=extent<2; previous.disabled=position<2; next.disabled=position>=extent-2;
        };
        const ensure=button=> {
          if (!button) return;
          const vertical=wrapper.classList.contains('g24-rail-vertical'), a=list.getBoundingClientRect(), b=button.getBoundingClientRect();
          const delta=vertical ? (b.top<a.top?b.top-a.top:b.bottom>a.bottom?b.bottom-a.bottom:0) : (b.left<a.left?b.left-a.left:b.right>a.right?b.right-a.right:0);
          if (delta) list.scrollBy({top:vertical?delta:0,left:vertical?0:delta,behavior:'instant'});
          update();
        };
        list.addEventListener('scroll',update,{...options,passive:true});
          const resize=new ResizeObserver(() => { update(); ensure(list.querySelector(native ? '[aria-current="true"]' : '[aria-pressed="true"]')); }); resize.observe(list);
        let mutation;
        if (native) {
          mutation=new MutationObserver(()=>ensure(list.querySelector('[aria-current="true"]')));
          mutation.observe(list,{subtree:true,attributes:true,attributeFilter:['aria-current']});
        }
        const rail={list,update,ensure,resize,mutation}; this.rails.push(rail); update(); return rail;
      }
      imageKey(source) { return decodeURIComponent(new URL(source, location.href).pathname.split('/').pop()); }
      registerStoryImages(options) {
        for (const link of document.querySelectorAll('.g24-story a[href],.g24-editorial-chapter a[href],.green24-product-details a[href]')) {
          const photo = link.querySelector('img');
          if (!photo || !/\.(png|jpe?g|webp|avif)$/i.test(new URL(link.href).pathname) || this.imageKey(link.href) !== this.imageKey(photo.currentSrc || photo.src)) continue;
          if (this.images.some(image => this.imageKey(image.src) === this.imageKey(link.href))) continue;
          const width = photo.naturalWidth || Number(photo.getAttribute('width'));
          const height = photo.naturalHeight || Number(photo.getAttribute('height'));
          if (!width || !height) continue;
          const index = this.images.length, id = `story-${index}`;
          const data = { id,src:link.href,width,ratio:width/height,alt:photo.alt,branded:false };
          const button = document.createElement('button');
          button.type='button'; button.dataset.viewerThumb=''; button.dataset.imageId=id;
          button.setAttribute('aria-label',this.dataset.imageLabel.replace('[index]',index+1)); button.setAttribute('aria-pressed','false');
          const thumb = document.createElement('img'); thumb.src=photo.currentSrc || photo.src; thumb.alt=''; thumb.loading='lazy';
          button.append(thumb); button.addEventListener('click',()=>this.select(index),options);
          this.querySelector('.g24-image-dialog__thumbnails').append(button);
          this.images.push(data); this.thumbs.push(button);
        }
        this.viewerRail.update();
      }
      activeId() {
        const active = this.gallery.querySelector('.product__media-item.is-active') || this.gallery.querySelector('.product__media-item');
        return active?.querySelector('.product__media-toggle')?.dataset.mediaId || this.images[0].id;
      }
      open(id, opener) {
        this.hideMagnifier(); this.opener = opener; this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal(); document.body.style.overflow = 'hidden';
        this.select(Math.max(0, this.images.findIndex(image => image.id === id)));
          requestAnimationFrame(() => { if (this.dialog.open) { this.setZoom(1); this.viewerRail.ensure(this.thumbs[this.index]); } });
        this.querySelector('[data-close-viewer]').focus();
      }
      select(index) {
        this.clearGesture();
        this.index = (index + this.images.length) % this.images.length;
        const selected = this.images[this.index];
        const preview = this.gallery.querySelector('[data-media-id="' + this.dataset.section + '-' + selected.id + '"] .product__media img');
        const previewSource = preview?.complete && preview.naturalWidth ? preview.currentSrc || preview.src : '';
        const status = this.querySelector('[data-viewer-status]');
        this.image.alt = selected.alt;
        if (previewSource) this.image.src = previewSource;
        else this.image.removeAttribute('src');
        if (status) { status.textContent = status.dataset.loading; status.hidden = Boolean(previewSource); }
        const request = this.imageRequest = {};
        const detail = new Image();
        detail.onload = () => {
          if (this.imageRequest !== request || !this.isConnected) return;
          this.image.src = selected.src;
          if (status) status.hidden = true;
          this.setZoom(1);
        };
        detail.onerror = () => {
          if (this.imageRequest !== request || !this.isConnected) return;
          if (status) { status.textContent = status.dataset.error; status.hidden = Boolean(previewSource); }
        };
        detail.src = selected.src;
        this.thumbs.forEach(button => {
          const native = this.gallery.querySelector('[data-target="' + this.dataset.section + '-' + button.dataset.imageId + '"] img');
          const thumb = button.querySelector('img');
          if (native?.complete && native.naturalWidth && thumb) { thumb.removeAttribute('srcset'); thumb.src = native.currentSrc || native.src; }
        });
        if (this.brand) this.brand.hidden = !selected.branded;
        this.querySelector('[data-viewer-caption]').textContent = selected.alt;
        this.querySelector('[data-viewer-counter]').textContent = this.dataset.counter.replace('[current]',this.index+1).replace('[total]',this.images.length);
        this.thumbs.forEach((button,index) => button.setAttribute('aria-pressed',String(index===this.index)));
        this.viewerRail.ensure(this.thumbs[this.index]);
        this.querySelector('[data-previous]').disabled = this.images.length < 2; this.querySelector('[data-next]').disabled = this.images.length < 2;
        this.setZoom(1);
      }
      clearGesture() {
        const ids = Array.from(this.pointers?.keys() || []);
        this.pointers?.clear(); this.drag = null; this.pinch = null; this.pinching = false; this.lastTap = null;
        this.stage?.classList.remove('is-dragging');
        for (const id of ids) if (this.stage?.hasPointerCapture?.(id)) this.stage.releasePointerCapture(id);
      }
      gesturePoint(x, y) {
        const box = this.stage.getBoundingClientRect();
        return { x: x - box.left - box.width / 2, y: y - box.top - box.height / 2 };
      }
      beginPinch() {
        const [a, b] = Array.from(this.pointers.values());
        const center = this.gesturePoint((a.x + b.x) / 2, (a.y + b.y) / 2);
        this.pinch = { distance: Math.max(1, Math.hypot(b.x - a.x, b.y - a.y)), zoom: this.zoom, panX: this.panX, panY: this.panY, originX: center.x, originY: center.y };
        this.pinching = true; this.lastTap = null; this.drag = null;
        for (const point of this.pointers.values()) point.moved = true;
        this.stage.classList.remove('is-dragging');
      }
      startPointer(event) {
        if (event.pointerType === 'mouse' && (event.button !== 0 || this.zoom <= 1)) return;
        if (this.pointers.size >= 2 || this.pointers.has(event.pointerId)) return;
        event.preventDefault();
        const point = { x: event.clientX, y: event.clientY, startX: event.clientX, startY: event.clientY, time: event.timeStamp, type: event.pointerType, moved: false };
        this.pointers.set(event.pointerId, point);
        this.stage.setPointerCapture(event.pointerId);
        if (this.pointers.size === 2) this.beginPinch();
        else {
          this.drag = { x: point.x, y: point.y, left: this.panX, top: this.panY };
          if (this.zoom > 1) this.stage.classList.add('is-dragging');
        }
      }
      movePointer(event) {
        const point = this.pointers.get(event.pointerId); if (!point) return;
        event.preventDefault(); point.x = event.clientX; point.y = event.clientY;
        if (Math.hypot(point.x - point.startX, point.y - point.startY) > 8) point.moved = true;
        if (this.pointers.size === 2 && this.pinch) {
          const [a, b] = Array.from(this.pointers.values());
          const center = this.gesturePoint((a.x + b.x) / 2, (a.y + b.y) / 2);
          this.setZoom(this.pinch.zoom * Math.hypot(b.x - a.x, b.y - a.y) / this.pinch.distance, { ...this.pinch, ...center });
        } else if (this.zoom > 1 && this.drag) {
          this.panX = this.drag.left + point.x - this.drag.x; this.panY = this.drag.top + point.y - this.drag.y;
          this.positionImage();
        }
      }
      endPointer(event) {
        const point = this.pointers.get(event.pointerId); if (!point) return;
        this.pointers.delete(event.pointerId);
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        if (this.pointers.size) {
          const remaining = this.pointers.values().next().value;
          remaining.moved = true; this.pinch = null;
          this.drag = { x: remaining.x, y: remaining.y, left: this.panX, top: this.panY };
          this.stage.classList.toggle('is-dragging', this.zoom > 1);
          return;
        }
        const deltaX = event.clientX - point.startX, deltaY = event.clientY - point.startY;
        if (point.type === 'touch' && !this.pinching && this.zoom <= 1 && event.timeStamp - point.time < 600 && Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY) * 1.4) {
          this.select(this.index + (deltaX < 0 ? 1 : -1)); return;
        }
        const isTap = point.type === 'touch' && !point.moved && !this.pinching && event.timeStamp - point.time < 300;
        if (isTap) {
          const previous = this.lastTap;
          if (previous && event.timeStamp - previous.time < 320 && Math.hypot(point.x - previous.x, point.y - previous.y) < 28) {
            const center = this.gesturePoint(point.x, point.y);
            this.setZoom(this.zoom > 1 ? 1 : 2.5, { ...center, originX: center.x, originY: center.y, zoom: this.zoom, panX: this.panX, panY: this.panY });
            this.lastTap = null;
          } else this.lastTap = { x: point.x, y: point.y, time: event.timeStamp };
        } else this.lastTap = null;
        this.drag = null; this.pinch = null; this.pinching = false; this.stage.classList.remove('is-dragging');
      }
      setZoom(value, anchor = null) {
        const selected=this.images[this.index]; if (!selected || !this.stage.clientWidth || !this.stage.clientHeight) return;
        const naturalHeight=selected.width/selected.ratio;
        const fit=Math.max(.01,Math.min((this.stage.clientWidth-24)/selected.width,(this.stage.clientHeight-24)/naturalHeight,1));
        const max=Math.max(1,Math.min(4,1/fit)); this.zoom=Math.max(1,Math.min(max,value));
        this.imageWidth=Math.floor(selected.width*fit*this.zoom); this.imageHeight=Math.floor(naturalHeight*fit*this.zoom);
        this.image.style.width=`${this.imageWidth}px`; this.image.style.height=`${this.imageHeight}px`;
        if (anchor) {
          const ratio = this.zoom / anchor.zoom;
          this.panX = anchor.x - (anchor.originX - anchor.panX) * ratio;
          this.panY = anchor.y - (anchor.originY - anchor.panY) * ratio;
        } else { this.panX=0; this.panY=0; }
        this.positionImage();
        this.stage.classList.toggle('is-zoomed',this.zoom>1);
        this.querySelector('[data-zoom-level]').textContent=`${Math.round(this.zoom*100)}%`;
        this.querySelector('[data-zoom-out]').disabled=this.zoom<=1;
        this.querySelector('[data-zoom-in]').disabled=this.zoom>=max-.01;
        this.querySelector('[data-fit]').setAttribute('aria-pressed',String(this.zoom<=1));
      }
      positionImage() {
        const limitX=Math.max(0,(this.imageWidth-this.stage.clientWidth)/2),limitY=Math.max(0,(this.imageHeight-this.stage.clientHeight)/2);
        this.panX=Math.max(-limitX,Math.min(limitX,this.panX)); this.panY=Math.max(-limitY,Math.min(limitY,this.panY));
        this.image.style.transform=`translate(calc(-50% + ${this.panX}px),calc(-50% + ${this.panY}px))`;
        if (this.brand && !this.brand.hidden) {
          const right = Math.max(10, (this.stage.clientWidth - this.imageWidth) / 2 - this.panX + 10);
          const bottom = Math.max(10, (this.stage.clientHeight - this.imageHeight) / 2 - this.panY + 10);
          this.brand.style.right = `${right}px`; this.brand.style.bottom = `${bottom}px`;
        }
      }
      hideMagnifier() { this.pane.hidden = true; this.lens.hidden = true; }
      magnify(event) {
        if (this.dialog.open || !matchMedia('(min-width:1100px) and (hover:hover) and (pointer:fine)').matches) { this.hideMagnifier(); return; }
        const id=this.activeId(), selected=this.images.find(image=>image.id===id);
        const active=this.gallery.querySelector('.product__media-item.is-active') || this.gallery.querySelector('.product__media-item');
        const image=active?.querySelector('.product__modal-opener--image .product__media img');
        if (!selected || !image) { this.hideMagnifier(); return; }
        const box=image.getBoundingClientRect(), fit=Math.min(box.width/selected.width,box.height/(selected.width/selected.ratio));
        const width=selected.width*fit,height=width/selected.ratio,left=box.left+(box.width-width)/2,top=box.top+(box.height-height)/2;
        const x=event.clientX-left,y=event.clientY-top,right=this.gallery.getBoundingClientRect().right+16;
        if (x<0 || y<0 || x>width || y>height || innerWidth-right<240) { this.hideMagnifier(); return; }
        const paneWidth=Math.min(580,innerWidth-right-24),paneHeight=Math.min(540,innerHeight-140),zoom=Math.min(3,1/fit);
        if (zoom<=1.1) { this.hideMagnifier(); return; }
        const paneTop=Math.max(80,Math.min(top,innerHeight-paneHeight-20));
        Object.assign(this.pane.style,{left:`${right}px`,top:`${paneTop}px`,width:`${paneWidth}px`,height:`${paneHeight}px`});
        if (this.paneImage.getAttribute('src')!==selected.src) this.paneImage.src=selected.src;
        const zoomWidth=width*zoom,zoomHeight=height*zoom;
        const offsetX=Math.max(0,Math.min(zoomWidth-paneWidth,x*zoom-paneWidth/2)),offsetY=Math.max(0,Math.min(zoomHeight-paneHeight,y*zoom-paneHeight/2));
        Object.assign(this.paneImage.style,{width:`${zoomWidth}px`,height:`${zoomHeight}px`,left:`${zoomWidth<paneWidth?(paneWidth-zoomWidth)/2:-offsetX}px`,top:`${zoomHeight<paneHeight?(paneHeight-zoomHeight)/2:-offsetY}px`});
        const lensWidth=Math.min(width,paneWidth/zoom),lensHeight=Math.min(height,paneHeight/zoom);
        Object.assign(this.lens.style,{width:`${lensWidth}px`,height:`${lensHeight}px`,left:`${left+Math.max(0,Math.min(width-lensWidth,x-lensWidth/2))}px`,top:`${top+Math.max(0,Math.min(height-lensHeight,y-lensHeight/2))}px`});
        this.pane.hidden=false;this.lens.hidden=false;
      }
    });
  }
